document.addEventListener("DOMContentLoaded", () => {
	const productRecipeCarousels = document.querySelectorAll(".product-and-recipe-carousel__swiper-wrapper");

	if (productRecipeCarousels) {
		productRecipeCarousels.forEach((carousel) => {
			const imageSwiper = new Swiper(carousel.querySelector(".product-and-recipe-carousel__image-swiper"), {
				// Optional parameters
				spaceBetween: 30,
				effect: "fade",
				keyboard: true,
				allowTouchMove: false,
				slidesPerView: 1,

				// Navigation arrows
				navigation: {
					nextEl: carousel.querySelector(".product-and-recipe-carousel__swiper-navigation .swiper-button-next"),
					prevEl: carousel.querySelector(".product-and-recipe-carousel__swiper-navigation .swiper-button-prev"),
				},
			});

			const productSwiper = new Swiper(carousel.querySelector(".product-and-recipe-carousel__product-swiper"), {
				// Optional parameters
				spaceBetween: 30,
				effect: "fade",
				keyboard: true,
				allowTouchMove: false,
				slidesPerView: 1,
			});

			const recipeSwiper = new Swiper(carousel.querySelector(".product-and-recipe-carousel__recipe-swiper"), {
				// Optional parameters
				spaceBetween: 30,
				effect: "fade",
				keyboard: true,
				allowTouchMove: false,
				slidesPerView: 1,
			});

			// synchronise the three swipers
			imageSwiper.controller.control = [productSwiper, recipeSwiper];
		});
	}
});
